<div class="skeleton-loader">
  <div class="skeleton-row">
    <div class="skeleton-line short"></div>
    <div class="skeleton-circle"></div>
    <div class="skeleton-circle"></div>
  </div>
  <div class="skeleton-row">
    <div class="skeleton-line long"></div>
    <div class="skeleton-circle"></div>
    <div class="skeleton-circle"></div>
  </div>
  <div class="skeleton-row">
    <div class="skeleton-line short"></div>
    <div class="skeleton-circle"></div>
    <div class="skeleton-circle"></div>
  </div>
  <div class="skeleton-row">
    <div class="skeleton-line long"></div>
    <div class="skeleton-circle"></div>
    <div class="skeleton-circle"></div>
  </div>
  <div class="skeleton-row">
    <div class="skeleton-line short"></div>
    <div class="skeleton-circle"></div>
    <div class="skeleton-circle"></div>
  </div>
</div>